// import { crud } from '../stores/crud';
import makeModule, { makeModules, makeIt } from './crud';
import modules from './modules';
import auth from "./modules/auth";
import crud from "./crud";
import cart from "./modules/cart";

export default {
    strict: process.env.NODE_ENV !== 'production',
    state: { popup: false },
    mutations: {
        TOGGLE: state => state.popup = !state.popup
    },
    actions: {
        toggle: ({commit}) => commit('TOGGLE')
    },
    modules: {
        utilisateur: makeModules({service: crud('accounts')}),
        cessationsAgent: makeIt({service: crud('cessationsAgent')}),
        paiement: makeModule({service: crud('payements')}),
        users: makeModules({service: crud('users/actions')}),
        assignation: makeModules({service: crud('assignations')}),
        permissions: makeModules({service: crud('permission')}),
        role: makeModules({service: crud('role')}),
        contact: makeModules({service: crud('contacts')}),
        organisation: makeModules({service: crud('organisation')}),
        poste: makeModules({service: crud('poste')}),
        ...modules,
        classeurs: makeModules({service: crud('classeurs')}),
        meteo: makeIt({service: crud('meteo')}),
        gouvernance: makeModules({service: crud('gouvernance')}),
        realisation: makeIt({service: crud('realisation')}),
        composantes: makeModules({service: crud('composantes')}),
        generationPta: makeIt({service: crud('generationPta')}),
        projetPag: makeIt({service: crud('projetPag')}),
        objectif: makeIt({service: crud('objectif')}),
        typeGouvernance: makeModules({service: crud('typeGouvernance')}),
        p4wProjects: makeIt({service: crud('p4wProjects')}),
        auth,
        cart
    }

}
